(function () {
if (window.__nbpProductJs) return;
window.__nbpProductJs = true;
var doc = document;
var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
function store(key, value) {
try {
if (value === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
localStorage.setItem(key, JSON.stringify(value));
} catch (e) { return null; }
}
function initProduct(root) {
if (root.dataset.nbpReady) return;
root.dataset.nbpReady = '1';
var section = root.closest('.nbp-pdp-section') || root;
var dataEl = section.querySelector('[data-nbp-product-json]');
var data = {};
try { data = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { data = {}; }
var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nbp-pdp-slide]'));
var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nbp-thumb]'));
var gallery = root.querySelector('[data-nbp-gallery]');
var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
function go(i) {
if (!slides.length) return;
i = (i + slides.length) % slides.length;
if (i === current) return;
var prevSlide = slides[current];
var video = prevSlide && prevSlide.querySelector('video');
if (video) video.pause();
slides.forEach(function (s, n) {
var on = n === i;
s.classList.toggle('is-active', on);
if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
});
thumbs.forEach(function (t, n) {
t.classList.toggle('is-active', n === i);
if (n === i) {
t.setAttribute('aria-current', 'true');
var row = t.parentElement;
if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: t.offsetLeft - row.clientWidth / 2 + t.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
} else t.removeAttribute('aria-current');
});
current = i;
}
root._nbpGoToMedia = function (mediaId) {
if (!mediaId) return;
var idx = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
if (idx > -1) go(idx);
};
thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.nbpThumb)); }); });
var prevBtn = root.querySelector('[data-nbp-gallery-prev]');
var nextBtn = root.querySelector('[data-nbp-gallery-next]');
if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
if (gallery) {
gallery.setAttribute('tabindex', '0');
gallery.setAttribute('aria-roledescription', 'carousel');
gallery.addEventListener('keydown', function (e) {
if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
});
var sx = null, sy = null;
gallery.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
gallery.addEventListener('touchend', function (e) {
if (sx === null) return;
var dx = e.changedTouches[0].clientX - sx;
var dy = e.changedTouches[0].clientY - sy;
if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
sx = sy = null;
}, { passive: true });
}
root.querySelectorAll('[data-nbp-zoom]').forEach(function (zoom) {
var img = zoom.querySelector('img');
if (!img) return;
var raf = null;
function move(e) {
if (!canHover.matches) return;
var rect = zoom.getBoundingClientRect();
var x = ((e.clientX - rect.left) / rect.width) * 100;
var y = ((e.clientY - rect.top) / rect.height) * 100;
if (raf) cancelAnimationFrame(raf);
raf = requestAnimationFrame(function () {
zoom.style.setProperty('--nbp-zx', Math.max(0, Math.min(100, x)) + '%');
zoom.style.setProperty('--nbp-zy', Math.max(0, Math.min(100, y)) + '%');
});
}
zoom.addEventListener('pointerenter', function (e) {
if (!canHover.matches || e.pointerType !== 'mouse') return;
move(e);
zoom.classList.add('is-zooming');
});
zoom.addEventListener('pointermove', move);
zoom.addEventListener('pointerleave', function () { zoom.classList.remove('is-zooming'); });
});
var share = root.querySelector('[data-nbp-share]');
if (share) {
share.addEventListener('click', function () {
var url = window.location.href;
var title = doc.title;
if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
var toast = share.querySelector('[data-nbp-share-toast]');
var done = function () { if (toast) { toast.hidden = false; setTimeout(function () { toast.hidden = true; }, 1600); } };
if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
});
}
var wish = root.querySelector('[data-nbp-wishlist]');
if (wish) {
var handle = root.dataset.handle;
var list = store('nbp-wishlist') || [];
var set = function (on) {
wish.setAttribute('aria-pressed', on ? 'true' : 'false');
wish.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
wish.classList.toggle('is-on', on);
};
set(list.indexOf(handle) > -1);
wish.addEventListener('click', function () {
list = store('nbp-wishlist') || [];
var i = list.indexOf(handle);
if (i > -1) list.splice(i, 1); else list.push(handle);
store('nbp-wishlist', list);
set(i === -1);
});
}
var desc = root.querySelector('[data-nbp-desc]');
var descBtn = root.querySelector('[data-nbp-desc-toggle]');
if (desc && descBtn) {
var check = function () {
if (desc.classList.contains('is-open')) return;
descBtn.hidden = desc.scrollHeight <= desc.clientHeight + 2;
desc.classList.toggle('is-clamped', !descBtn.hidden);
};
check();
window.addEventListener('load', check);
descBtn.addEventListener('click', function () {
var open = !desc.classList.contains('is-open');
desc.classList.toggle('is-open', open);
desc.classList.toggle('is-clamped', !open);
descBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
descBtn.querySelector('[data-more]').hidden = open;
descBtn.querySelector('[data-less]').hidden = !open;
});
}
var idInput = root.querySelector('[data-nbp-variant-input]');
var atc = root.querySelector('[data-nbp-atc]');
var atcLabel = root.querySelector('[data-nbp-atc-label]');
var buy = root.querySelector('[data-nbp-buy-now]');
var priceEl = root.querySelector('[data-nbp-price]');
var compareEl = root.querySelector('[data-nbp-compare]');
var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-nbp-option]'));
var variants = data.variants || [];
var labels = data.labels || { add: 'Add To Cart', soldOut: 'Sold Out', unavailable: 'Unavailable' };
function selected() {
return fieldsets.map(function (fs) {
var c = fs.querySelector('[data-nbp-option-input]:checked');
return c ? c.value : null;
});
}
function findVariant(opts) {
return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
}
function markAvailability(opts) {
fieldsets.forEach(function (fs, idx) {
fs.querySelectorAll('[data-nbp-option-input]').forEach(function (input) {
var test = opts.slice();
test[idx] = input.value;
var v = findVariant(test);
var label = fs.querySelector('label[for="' + input.id + '"]');
if (label) label.classList.toggle('is-unavailable', !v || !v.available);
});
});
}
function setButtons(v) {
var ok = Boolean(v && v.available);
if (atc) {
atc.disabled = !ok;
if (v) atc.dataset.variantId = v.id;
}
if (buy) buy.disabled = !ok;
if (atcLabel) atcLabel.textContent = !v ? labels.unavailable : ok ? labels.add : labels.soldOut;
}
function onChange() {
var opts = selected();
var v = findVariant(opts);
fieldsets.forEach(function (fs, i) {
var out = fs.querySelector('[data-nbp-option-value]');
if (out) out.textContent = opts[i] || '';
});
markAvailability(opts);
setButtons(v);
if (!v) return;
if (idInput) idInput.value = v.id;
if (priceEl) priceEl.textContent = v.price;
if (compareEl) { compareEl.hidden = !v.compare; if (v.compare) compareEl.textContent = v.compare; }
if (v.media) root._nbpGoToMedia(v.media);
try {
var url = new URL(window.location.href);
url.searchParams.set('variant', v.id);
window.history.replaceState({}, '', url.toString());
} catch (e) {}
}
if (fieldsets.length) {
root.addEventListener('change', function (e) { if (e.target.matches('[data-nbp-option-input]')) onChange(); });
markAvailability(selected());
}
var qtyInput = root.querySelector('[data-nbp-qty-input]');
function syncQty() {
var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
if (qtyInput) qtyInput.value = q;
if (atc) atc.dataset.quantity = q;
return q;
}
root.querySelectorAll('[data-nbp-qty]').forEach(function (b) {
b.addEventListener('click', function () {
if (!qtyInput) return;
qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.nbpQty));
syncQty();
});
});
if (qtyInput) qtyInput.addEventListener('change', syncQty);
if (buy) {
buy.addEventListener('click', function () {
var id = idInput ? idInput.value : atc && atc.dataset.variantId;
if (!id || buy.classList.contains('is-loading')) return;
buy.classList.add('is-loading');
var routes = (window.Theme && window.Theme.routes) || {};
fetch(routes.cart_add_url || '/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: [{ id: Number(id), quantity: syncQty() }] }),
})
.then(function (r) { return r.json(); })
.then(function (res) {
if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
window.location.href = '/checkout';
})
.catch(function (err) {
buy.classList.remove('is-loading');
var msg = root.querySelector('[data-nbp-pdp-error]');
if (msg) { msg.textContent = err.message; msg.hidden = false; setTimeout(function () { msg.hidden = true; }, 4000); }
});
});
}
var dialog = section.querySelector('[data-nbp-chart-dialog]');
root.querySelectorAll('[data-nbp-open-chart]').forEach(function (b) {
b.addEventListener('click', function () { if (dialog && dialog.showModal) dialog.showModal(); });
});
if (dialog) {
dialog.querySelector('[data-nbp-close-chart]').addEventListener('click', function () { dialog.close(); });
dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
}
}
function initReviews(root) {
if (root.dataset.nbpReady) return;
root.dataset.nbpReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('[data-nbp-review]'));
if (root.dataset.sort === 'date') {
items.sort(function (a, b) { return Number(b.dataset.date) - Number(a.dataset.date); });
var ul = root.querySelector('[data-nbp-review-list]');
if (ul) items.forEach(function (it) { ul.appendChild(it); });
}
var perPage = Number(root.dataset.perPage) || 4;
var pager = root.querySelector('[data-nbp-review-pager]');
var empty = root.querySelector('[data-nbp-review-empty]');
var list = root.querySelector('[data-nbp-review-list]');
var tab = 'all';
var page = 1;
function checked(sel) {
return Array.prototype.slice.call(root.querySelectorAll(sel + ':checked')).map(function (i) { return i.value; });
}
function matches(item) {
var ratings = checked('[data-nbp-filter-rating]');
var topics = checked('[data-nbp-filter-topic]');
if (ratings.length && ratings.indexOf(item.dataset.rating) === -1) return false;
if (topics.length) {
var its = (item.dataset.topics || '').split('|');
if (!topics.some(function (t) { return its.indexOf(t) > -1; })) return false;
}
if (tab === 'media' && item.dataset.media !== 'true') return false;
if (tab === 'text' && item.dataset.text !== 'true') return false;
return true;
}
function pageButtons(pages) {
var out = [];
var add = function (n) { if (out.indexOf(n) === -1 && n >= 1 && n <= pages) out.push(n); };
add(1); add(page - 1); add(page); add(page + 1); add(pages);
out.sort(function (a, b) { return a - b; });
var html = '';
out.forEach(function (n, i) {
if (i && n - out[i - 1] > 1) html += '<span class="nbp-rv__page is-gap" aria-hidden="true">…</span>';
html += '<button type="button" class="nbp-rv__page' + (n === page ? ' is-current' : '') + '" data-page="' + n + '"' + (n === page ? ' aria-current="page"' : '') + ' aria-label="Page ' + n + '">' + n + '</button>';
});
html += '<button type="button" class="nbp-rv__page is-next" data-page="' + Math.min(pages, page + 1) + '" aria-label="Next page"' + (page >= pages ? ' disabled' : '') + '><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9.5 6 6 6-6 6"/></svg></button>';
return html;
}
function render(scroll) {
var visible = items.filter(matches);
var pages = Math.max(1, Math.ceil(visible.length / perPage));
page = Math.min(page, pages);
items.forEach(function (it) { it.hidden = true; });
visible.slice((page - 1) * perPage, page * perPage).forEach(function (it) { it.hidden = false; });
if (empty) empty.hidden = visible.length > 0;
if (pager) {
pager.hidden = pages <= 1;
pager.innerHTML = pages > 1 ? pageButtons(pages) : '';
}
if (scroll && list) {
var top = list.getBoundingClientRect().top;
if (top < 0) list.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
}
}
root.addEventListener('change', function (e) {
if (e.target.matches('[data-nbp-filter-rating],[data-nbp-filter-topic]')) { page = 1; render(); }
});
root.querySelectorAll('[data-nbp-tab]').forEach(function (b) {
b.addEventListener('click', function () {
tab = b.dataset.nbpTab;
root.querySelectorAll('[data-nbp-tab]').forEach(function (x) {
var on = x === b;
x.classList.toggle('is-active', on);
x.setAttribute('aria-selected', on ? 'true' : 'false');
});
page = 1;
render();
});
});
if (pager) pager.addEventListener('click', function (e) {
var b = e.target.closest('[data-page]');
if (!b || b.disabled) return;
page = Number(b.dataset.page);
render(true);
});
var votes = store('nbp-review-votes') || {};
items.forEach(function (it) {
var id = it.dataset.id;
var up = it.querySelector('[data-nbp-vote="up"]');
var down = it.querySelector('[data-nbp-vote="down"]');
var count = up && up.querySelector('[data-nbp-vote-count]');
var base = up ? Number(up.dataset.base) || 0 : 0;
function paint() {
var v = votes[id];
if (up) { up.setAttribute('aria-pressed', v === 'up' ? 'true' : 'false'); up.classList.toggle('is-on', v === 'up'); }
if (down) { down.setAttribute('aria-pressed', v === 'down' ? 'true' : 'false'); down.classList.toggle('is-on', v === 'down'); }
if (count) count.textContent = base + (v === 'up' ? 1 : 0);
}
function vote(dir) {
votes = store('nbp-review-votes') || {};
votes[id] = votes[id] === dir ? null : dir;
store('nbp-review-votes', votes);
paint();
}
if (up) up.addEventListener('click', function () { vote('up'); });
if (down) down.addEventListener('click', function () { vote('down'); });
paint();
});
var openBtn = root.querySelector('[data-nbp-review-open]');
var panel = root.querySelector('[data-nbp-review-panel]');
if (openBtn && panel) {
openBtn.addEventListener('click', function () {
var open = panel.hidden;
panel.hidden = !open;
openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
if (open) {
var first = panel.querySelector('input:not([type="hidden"]):not(.nbp-sr), textarea');
if (first) setTimeout(function () { first.focus(); }, 50);
}
});
if (panel.querySelector('[data-nbp-review-posted]')) {
panel.hidden = false;
openBtn.setAttribute('aria-expanded', 'true');
setTimeout(function () { panel.scrollIntoView({ behavior: 'auto', block: 'center' }); }, 60);
}
}
render();
}
function init(scope) {
(scope || doc).querySelectorAll('[data-nbp-pdp]').forEach(initProduct);
(scope || doc).querySelectorAll('[data-nbp-reviews]').forEach(initReviews);
}
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
else init();
doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();